exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "/* Colors */\n/* Sizes */\n/* Breakpoints */\n/* Mobile */\n/* Fonts */\n.DesktopMain__desktopMain___M1roQD2N {\n  background-size: cover;\n  background-repeat: no-repeat;\n  background-position: center;\n}\n.DesktopMain__homeLogo___3-Kh5Q5Q {\n  margin-bottom: 27px;\n  text-align: center;\n  max-width: 169px;\n}\n.DesktopMain__homeTitle___3tZMObd6 {\n  color: #fff;\n  font-family: 'Dekers', sans-serif;\n  font-weight: 700;\n  font-size: 17px;\n  text-align: center;\n  margin-bottom: 29px;\n}\n", ""]);
// Exports
exports.locals = {
	"desktopMain": "DesktopMain__desktopMain___M1roQD2N",
	"homeLogo": "DesktopMain__homeLogo___3-Kh5Q5Q",
	"homeTitle": "DesktopMain__homeTitle___3tZMObd6"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader/dist/cjs.js??ref--3-oneOf-0-1!./node_modules/vue-loader/lib/loaders/stylePostLoader.js!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib??vue-loader-options!./node_modules/eslint-loader??ref--0!./src/apps/desktop/components/DesktopMain.vue?vue&type=style&index=0&lang=scss&module=true&
// module id = lS4P
// module chunks = 3